<template>
  <div class="row">
    <div class="col-12">
      <div class="row page-title-box align-items-center">
        <div class="col-md-auto">
          <h4 class="page-title mb-0">{{ title }}</h4>
        </div>
        <div class="col">
          <div class="float-end">
            <div class="btn-group me-4 mb-2 mb-sm-0">
              <router-link exact-active-class="active" class="btn btn-outline-light btn-bordered"
                :to="'/s/board/' + $route.params.team + '/' + $route.params.id + '/' + $route.params.alias + '/board'"
                @click.native="$emit('startUpdateInterval')">
                <i class="fas fa-th"></i>
                Quadros
              </router-link>
            </div>
            <div class="btn-group me-4 mb-2 mb-sm-0">
              <router-link exact-active-class="active" class="btn btn-outline-light btn-bordered"
                :to="'/s/board/' + $route.params.team + '/' + $route.params.id + '/' + $route.params.alias + '/pauta'"
                @click.native="$emit('stopUpdateInterval')">
                <i class="fa fa-list"></i>
                Pauta
              </router-link>
            </div>

            <div class="btn-group me-4 mb-2 mb-sm-0">
              <router-link exact-active-class="active" class="btn btn-outline-light btn-bordered"
                :to="'/s/board/' + $route.params.team + '/' + $route.params.id + '/' + $route.params.alias + '/dashboad'"
                @click.native="$emit('stopUpdateInterval')">
                <i class="fa fa-chart-pie"></i>
                Dashboard 
              </router-link>
            </div>

            <div class="btn-group me-4 mb-2 mb-sm-0" v-if="userAdmin === 1">
              <a @click="openConfig" class="btn btn-outline-light btn-bordered">
                <i class="fa fa-wrench"></i>
                Configurações
              </a>
            </div>
            <app-card-search :data="data" @openForm="openForm" />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppCardSearch from "@/views/system/boards/AppCardSearch.vue"
export default {
  name: "AppBaordHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    userAdmin: {
      type: Number,
      default: 0
    },
    data: {
      type: [Array, Object],
      required: false,
      default: () => []
    }
  },
  components: {
    AppCardSearch
  },
  methods: {
    openForm(bucket_id, task_id) {
      this.$emit("openForm", bucket_id, task_id);
    },
    openConfig(){
      this.$emit("setModalConfigShow");
    }
  }
};
</script>
<style scoped>
a.btn-bordered {
  border: none !important;
  border-bottom: 2px solid transparent !important;
  border-radius: 0px !important;
}

a.btn-bordered.active,
a.btn-bordered:hover,
a.btn-bordered.active:hover,
a.btn-bordered:focus,
a.btn-bordered.active:focus {
  background-color: transparent !important;
  background: transparent !important;
  color: #fff;
  border-bottom: 2px solid #fff !important;
}

.page-title-box {
  padding-bottom: 0px !important;
}
</style>